import IMask from "imask";

export default class Forms {
    constructor() {
        
        this.phoneField = document.querySelector(".telMask")
        this.dateField = document.querySelector(".dateMask")

        this.ready();
    }

    static serializeJSON(form) {
        const formData = new FormData(form);

        const pairs = {};

        for (const [name, value] of formData) {
            pairs[name] = value;
        }

        return JSON.stringify(pairs, null, 2);
    }

    static wrongMessages() {
        let mensagens = {
                messages: {
                    missingValue: {
                        checkbox: "Este campo é obrigatório.",
                        radio: "Por favor selecione um valor.",
                        select: "Por favor selecione um valor.",
                        "select-multiple":
                            "Por favor selecione pelo menos um valor.",
                        default: "Por favor preencha este campo",
                    },
                    patternMismatch: {
                        email: "Insira um endereço de e-mail corporativo válido.",
                        url: "Informe uma url.",
                        number: "Informe o telefone",
                        date: "Por favor utilizar o formato DD/MM/YYYY",
                        default: "Por favor, preencha o campo com conteúdo válido.",
                    },
                    outOfRange: {
                        over: "Selecione um valor que não seja superior a {max}.",
                        under: "Selecione um valor que não seja inferior a {min}.",
                    },
                    wrongLength: {
                        over: "Reduza este texto para não mais que {maxLength} caracteres. Você está usando atualmente {length} caracteres.",
                        under: "Por favor, estenda este texto para {minLength} caracteres ou mais. Você está usando atualmente {length} caracteres.",
                    },
                },
            };
        return mensagens;
    }

    static validarEmail(email) {
        // Lista de domÃ­nios bloqueados
        const dominiosBloqueados = ['gmail.com', 'yahoo.com', 'bing.com', 'hotmail.com', 'outlook.com', 'live.com', 'aol.com', 'icloud.com', 'ymail.com', 'msn.com', 'uol.com.br', 'terra.com.br', 'ig.com.br'];
      
        // Extrai o domÃ­nio do e-mail fornecido
        const dominio = email.split('@')[1];
      
        // Verifica se o domÃ­nio estÃ¡ na lista de domÃ­nios bloqueados
        if (dominiosBloqueados.includes(dominio)) {
          return false; // E-mail Ã© de um domÃ­nio bloqueado
        }
      
        // Verifica se o e-mail Ã© vÃ¡lido de acordo com o padrÃ£o
        const padraoEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return padraoEmail.test(email);
    }

    ready() {

        if(this.phoneField) {
            let phoneMask = IMask(this.phoneField, {
                mask: "(00) 00000-0000",
            });
        }

        if(this.dateField) {
            let dateMask = IMask(this.dateField, {
                mask: Date,
    
                pattern: "d/`m/`Y",
                blocks: {
                    d: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 31,
                    },
                    m: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12,
                    },
                    Y: {
                        mask: IMask.MaskedRange,
                        from: 19000,
                        to: 20290,
                    },
                },
            });
        }
    }
}